// Chakra's own tooltip paints itself gray.700/whiteAlpha.900 and has no idea
// about our palette, so every call site had to repeat bg/color. Setting it here
// means one source of truth, including for tooltips nobody has written yet.
//
// The colours go through --tooltip-bg / --tooltip-fg rather than plain bg/color
// because that is what Chakra's own baseStyle reads, and --popper-arrow-bg
// follows the background — set bg directly and the little arrow stays gray.
const Tooltip = {
  baseStyle: {
    bg: "var(--tooltip-bg)",
    color: "var(--tooltip-fg)",
    "--tooltip-bg": "colors.TooltipBg",
    "--tooltip-fg": "colors.TooltipColor",
    // extendTheme merges rather than replaces, so Chakra's own dark override
    // (gray.300 on gray.900) survives unless it is overridden too. Both modes
    // point at the same semantic token — the token already carries the dark value.
    _dark: {
      "--tooltip-bg": "colors.TooltipBg",
      "--tooltip-fg": "colors.TooltipColor",
    },
    "--popper-arrow-bg": "var(--tooltip-bg)",
  },
};

export default Tooltip;
